import initBarba from './packages/barba'

initBarba()
